import CrudPage from "@/components/CrudPage";
import { useAuth, canWrite } from "@/context/AuthContext";
import { Badge } from "@/components/ui/badge";

export default function MasterProduct() {
  const { user } = useAuth();
  const writeRoles = ["akuntansi", "admin_produksi"];
  return (
    <CrudPage
      title="Master Produk"
      subtitle="Daftar produk konstruksi ramah lingkungan."
      endpoint="/products"
      canWrite={canWrite(user?.role, writeRoles)}
      searchKeys={["code", "name", "jenis"]}
      columns={[
        { key: "code", label: "Kode" },
        { key: "name", label: "Nama Produk" },
        { key: "jenis", label: "Jenis" },
        { key: "satuan", label: "Satuan" },
        { key: "komposisi_standar", label: "Komposisi Standar" },
        { key: "status", label: "Status", render: (r) => <Badge className={r.status === "aktif" ? "bg-green-100 text-green-800 border-green-200 border" : "bg-slate-100 text-slate-600 border"}>{r.status}</Badge> },
      ]}
      fields={[
        { key: "code", label: "Kode Produk" },
        { key: "name", label: "Nama Produk" },
        { key: "jenis", label: "Jenis Produk", type: "select", options: ["Paving", "Beton Pracetak", "Batako", "Panel", "Beton"].map((v) => ({ value: v, label: v })) },
        { key: "satuan", label: "Satuan", type: "select", options: ["m³", "unit", "kg"].map((v) => ({ value: v, label: v })) },
        { key: "komposisi_standar", label: "Komposisi Standar", type: "textarea", full: true },
        { key: "status", label: "Status", type: "select", defaultValue: "aktif", options: [{ value: "aktif", label: "Aktif" }, { value: "nonaktif", label: "Nonaktif" }] },
      ]}
    />
  );
}
